import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Field } from "formik";
import { styled } from "../../theme";
import { FlexColumn, FlexRow } from "../../box";
import { FieldError } from "../atoms/field-error";
import { FieldLabel } from "../atoms/FieldLabel";
import { LockIcon } from "../atoms/LockIcon";
import { CheckboxItem } from "../atoms/checkbox-item";
import { OptionItem, OptionItemChildren } from "../atoms/option-item";
/**
 * A component that displays a group of checkboxes.
 *
 * @param {CheckboxGroupFieldProps<T>} props The props for the component.
 * @returns {JSX.Element} The rendered checkbox group field component.
 */
export const CheckboxGroupField = ({ name, options, label, disabled, OptionChildren, onChange, getOptionLabel, getOptionValue, getOptionKey, isChecked, renderOption, FormField, }) => {
    return (_jsxs(FlexColumn, { children: [label && _jsx(GroupLabel, { disabled: disabled, children: label }), _jsx(FieldError, { name: name }), _jsxs(FlexRow, { children: [_jsx(OptionItem, { children: options.map((option, index) => {
                            const element = (_jsx(FormField, { name: name, children: ({ form, field, }) => {
                                    const fieldValue = field.value || [];
                                    const checked = isChecked(option, fieldValue);
                                    return (_jsx(CheckboxItem, { name: name, value: getOptionValue(option), label: getOptionLabel(option), disabled: disabled || option.disabled, checked: checked, onChange: (event) => {
                                            field.onBlur(event);
                                            form.setFieldValue(name, toggleArrayValue(field.value, getOptionValue(option), event.currentTarget.checked), true);
                                            onChange(event);
                                        }, testId: `checkbox-${name}-${getOptionValue(option)}`, children: checked && OptionChildren && option.children && (_jsx(OptionItemChildren, { children: OptionChildren({
                                                children: option.children,
                                                index,
                                            }) })) }));
                                } }, getOptionKey(option, name)));
                            return (_jsx(Fragment, { children: renderOption(element, option, index) }, getOptionKey(option, name)));
                        }) }), disabled && _jsx(LockIcon, {})] })] }));
};
CheckboxGroupField.defaultProps = {
    onChange: () => { },
    renderOption: (element) => element,
    getOptionLabel: (option) => option.label,
    getOptionValue: (option) => option.value,
    getOptionKey: (option, name) => `${name}.${option.value}`,
    isChecked: (option, fieldValue) => fieldValue.includes(option.value),
    FormField: Field,
};
/**
 * Toggles a value in an array.
 *
 * @param {CheckboxValue} arr The array to toggle the value in.
 * @param {string} value The value to toggle.
 * @param {boolean} checked Whether the value should be added or removed.
 * @returns {CheckboxValue} The new array.
 */
function toggleArrayValue(arr, value, checked) {
    const set = new Set(arr);
    if (checked) {
        set.add(value);
    }
    else {
        set.delete(value);
    }
    return Array.from(set).filter(v => v);
}
const GroupLabel = styled(FieldLabel) `
  padding-bottom: 0.625em;
  word-break: break-word;
`;
